var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMNftClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7175 11.0377C46.6285 14.3358 51.0005 18 51.0005 18C51.0005 18 55.577 13.9677 57.2835 11.0377C59.2134 7.72424 60.0005 1.84085 60.0005 1.84085C60.0005 1.84085 56.5618 0 51.0005 0C45.4392 0 42.0005 1.84085 42.0005 1.84085C42.0005 1.84085 42.9257 7.94548 44.7175 11.0377Z",
    fill: "#FEA005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3247 12L14.3247 33.4926H35.8173V12L14.3247 12Z",
    fill: "#FEA005"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 47.1046,
    width: 12.8955,
    height: 12.8955,
    fill: "#FEA005"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.627,
    y: 47.1046,
    width: 12.8955,
    height: 12.8955,
    fill: "#FEA005"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.2529,
    y: 47.1046,
    width: 12.8955,
    height: 12.8955,
    fill: "#FEA005"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6445 39.9402V33.4924H26.5102V39.9402H23.6445Z",
    fill: "#FEA005"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87739 40.6566L7.87739 47.1044H5.01172L5.01172 40.6566H7.87739Z",
    fill: "#FEA005"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5102 40.6566V47.8208H23.6445V40.6566H26.5102Z",
    fill: "#FEA005"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1371 40.6566V47.1044H42.2715V40.6566H45.1371Z",
    fill: "#FEA005"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1311 41.3732L5.01172 41.3732L5.01172 38.5076L45.1311 38.5076L45.1311 41.3732Z",
    fill: "#FEA005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMNftClass);
export default __webpack_public_path__ + "static/media/m_nft_class.9356a26a266a13ec363110ee469494c4.svg";
export { ForwardRef as ReactComponent };